import { render, staticRenderFns } from "./newweeklybooking.vue?vue&type=template&id=dfaedee2&scoped=true"
import script from "./newweeklybooking.vue?vue&type=script&lang=js"
export * from "./newweeklybooking.vue?vue&type=script&lang=js"
import style0 from "./newweeklybooking.vue?vue&type=style&index=0&id=dfaedee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfaedee2",
  null
  
)

export default component.exports